import './TodoApp.css'
import {BrowserRouter, Routes , Route , useNavigate , useParams , Link, Navigate} from 'react-router-dom'

import LoginComponent from './LoginComponent';
import LougoutComponent from './LogoutComponent';
import WelcomeComponent from './WelcomeComponent';
import ListTodosComponent from './ListTodosComponent';
import ErrorComponent from './ErrorComponent';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import AuthProvider from './security/AuthContext';
import {  useAuth } from './security/AuthContext'
import TodoComponent from './TodoComponent';


function AuthenticatedRout({children}){
    const authContext = useAuth()
    console.log(authContext.isAuthenticated)
    
    if(authContext.isAuthenticated){
        return children
    }   
    return <Navigate to="/" />
}

export default function TodoApp(){

    return(
        
        <div className="TodoApp">
    <AuthProvider>
<BrowserRouter>
<HeaderComponent/>
<Routes>
<Route path='/' element={<LoginComponent/>} />    
<Route path='/login' element={<LoginComponent/>} />

<Route path='/welcome/:username' element={
    
    <AuthenticatedRout>
    <WelcomeComponent/>
    </AuthenticatedRout>
 } />

<Route path='/todos' element={
  <AuthenticatedRout>
     <ListTodosComponent/>
     </AuthenticatedRout>
      } />


<Route path='/todo/:id' element={
    
    <AuthenticatedRout>
    <TodoComponent/>
    </AuthenticatedRout>
 } />



<Route path='/logout' element={ 
    <AuthenticatedRout>
<LougoutComponent/>
</AuthenticatedRout>
} />

<Route path='*' element={ <LoginComponent/> } />

</Routes>
{/* <FooterComponent/> */}
</BrowserRouter>


</AuthProvider>
        </div>
    )
}
















